module.exports = __webpack_public_path__ + "static/media/Aneesa Razack.90704810.jpg";